export const TIN_FORMATTING_HELP_CENTER_ARTICLE_ID: string = '23084478133139';
export const INDIVIDUAL_TYPE: string = 'individual';
export const BUSINESS_TYPE: string = 'business';
